/* eslint-disable global-require */
module.exports = ['components.myartprice.common.verticalbar.content.m12', 'components.myartprice.common.verticalbar.content.m1'];
